<template>
  <span>
    <div class="row">
      <div class="col-md-4">
        <div class="mb-3">
          <label class="col-form-label">Requisition</label>
          <div class="col-sm-9">
            <my-select
              disableFormControl="true"
              :selection.sync="form.requisition_id"
              :suggestions="requisitions"
              placeholder="Select Requsition"
            ></my-select>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="mb-3">
          <label class="col-form-label">RFQ Number</label>
          <div class="col-sm-9">
            <input
              type="text"
              v-model="form.rfq_no"
              class="form-control"
              autocomplete="off"
              placeholder="RFQ Number"
            />
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="mb-3">
          <label class="col-form-label">RFD Date</label>
          <div class="col-sm-9">
            <my-datepicker
              :date.sync="form.rfd_date"
              placeholder="Enter RFD Date"
            ></my-datepicker>
          </div>
        </div>
      </div>
    </div>
  </span>
</template>

<script type="text/javascript">
import axios from "axios";
export default {
  name: "RfqDetailFormWidget",
  props: ["form"],
  data() {
    return {
      spareParts: [
        { id: 1, name: "Spare 1" },
        { id: 2, name: "Spare 2" },
      ],
      requisitions: [],
      isLoading: false,
    };
  },
  mounted() {
    this.getMasters();
  },
  methods: {
    async getMasters() {
      let masters = await axios.get(`rfqs/masters`);
      masters = masters.data;
      masters.requisitions.forEach((requisition) => {
        this.requisitions.push({
          id: requisition.id,
          name: requisition.requisition_no,
        });
      });
    },
  },
};
</script>
